
import { common as zhCommon } from './zh/common';
import { common as enCommon } from './en/common';

const messages = {
  zh: {
    translation: zhCommon
  },
  en: {
    translation: enCommon
  }
};

export default messages;
